import React, { Component } from "react";
import "./NewGrading.css";
import Logo from "../assets/logoCropped.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faUser,
  faUsers,
  faCheck,
  faQuestionCircle,
  faArrowRotateLeft,
  faHighlighter,
  faEraser,
  faChartSimple,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  faSpinnerThird,
  faUserDoctorMessage,
} from "@fortawesome/pro-solid-svg-icons";
import ActionLog from "./Components/ActionLog/ActionLog";
import logFetchError from "../Functions/LogFetchError";
import fetchSubmitLogs from "../Functions/FetchSubmitLogs";
import ViewCompletionsPopup from "./Components/ViewCompletionsPopup/ViewCompletionsPopup";
import { AnimatePresence, motion } from "framer-motion/dist/framer-motion";
import MDSpinner from "react-md-spinner";
import formatDateString from "../Functions/FormatDateString";
import formatTimeString from "../Functions/FormatTimeString";
import GamificationToastWrapper from "../Gamification/GamificationToastWrapper";

export default class NewGrading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedActionLogItem: 0,
      caseCompletionDate: null,
      reviewLater: this.props.reviewLater,
      highYield: false,
      selectedCaseData: {
        AvgGradeForCase: 0,
      },
      grading: null,
      gradingSections: [
        {
          title: "Diagnosis Orders",
          gradeValue: "FinalDiagnoisGrade",
          weightValue: "WEIGHTDIAGNOSIS",
        },
        {
          title: "Treatment Orders",
          gradeValue: "FinalTreatmentGrade",
          weightValue: "WEIGHTTREATMENT",
        },
        {
          title: "Preventive care",
          gradeValue: "FinalPreventiveCareGrade",
          weightValue: "WEIGHTPREVENTATIVE",
        },
        {
          title: "Timing",
          gradeValue: "FinalTimingGrade",
          weightValue: "WEIGHTTIMING",
        },
        {
          title: "Appropriate Orders",
          gradeValue: "FinalAppropriateGrade",
          weightValue: "WEIGHTAPPROPRIATE",
        },
        {
          title: "Appropriate Location / Appropriate Sequence",
          gradeValue: "FinalSequenceGrade",
          weightValue: "WEIGHTSEQUENCING",
        },
      ],
      viewPreviousCompletions: false,
      previousCompletionSelected: 0,
      previousCompletions: [],
      highYieldLoading: false,
      reviewLaterLoading: false,
      loadingStartCase: false,
      // --- Report card modal ---
      showReportCardModal: false,
      // --- Feedback button/modal ---
      showFeedbackModal: false,
      feedbackText: "",
      feedbackLoading: false,
      feedbackSubmitted: false,
      feedbackError: null,
      // --- Reading options ---
      showReadingOptions: false,
      readingFontSize: "medium", // "small" | "medium" | "large" | "xlarge"
      readingFontFamily: "sans", // "sans" | "serif" | "mono"
      readingLineHeight: "normal", // "compact" | "normal" | "relaxed"
      readingLetterSpacing: "normal", // "normal" | "wide"
      readingColorScheme: "default", // "default" | "mono" | "sepia" | "cool" | "highcontrast"
      // --- Highlighter ---
      highlighterActive: false,
      // Each highlight is a plain serializable object:
      // {
      //   id: string,
      //   containerType: "feedbackItem" | "caseDetails" | "caseSummary",
      //   containerKey: string,     // section title for feedback items, "caseDetails" for the details wrapper, "caseSummary" for the case summary block
      //   startOffset: number,      // character offset within the container's textContent
      //   endOffset: number,
      //   text: string,             // the highlighted text (used to validate / re-anchor on reload)
      //   createdAt: string,        // ISO timestamp
      // }
      highlights: [],
    };

    this.pageRef = React.createRef();
    this.HIGHLIGHT_REGISTRY_KEY = "cdmGradingHighlights";
    this.highlightApiSupported =
      typeof window !== "undefined" &&
      typeof window.Highlight === "function" &&
      typeof CSS !== "undefined" &&
      !!CSS.highlights;
  }

  componentDidMount() {
    // App loads the saved reading options on login; only fetch them here
    // if they haven't arrived (or this page is used without App's copy).
    if (this.props.savedReadingOptions) {
      this.applyReadingOptions(this.props.savedReadingOptions);
    } else {
      this.fetchReadingOptions();
    }

    if (this.props.gradingMode === "peek") {
      this.fetchPeekCaseGrade();
    } else {
      this.fetchViewCaseGrade();
    }

    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute(
      "content",
      this.props.selectedTheme.tertiaryBackgroundColor,
    );

    // Restore highlights previously saved via getHighlightsPayload()
    // (e.g. fetched from an API and passed down as a prop)
    if (this.props.savedHighlights) {
      this.loadHighlights(this.props.savedHighlights);
    }

    // --- Copy protection ---
    document.addEventListener("contextmenu", this.disableContextMenu);
    document.addEventListener("keydown", this.disableCopyCut);
    document.addEventListener("copy", this.disableCopyEvent);

    // --- Highlighter (mobile) ---
    // Touch-based selection (long-press + drag handles) is driven by the
    // browser/OS's native selection UI and does not reliably dispatch
    // "mouseup" (or even "touchend", once handles are being dragged) back to
    // our container. "selectionchange" is the one event that always fires
    // when the Selection object changes, regardless of whether a mouse or a
    // touch/handle-drag produced it, so it's the reliable cross-platform way
    // to detect "the user just finished selecting some text".
    document.addEventListener("selectionchange", this.handleSelectionChange);
  }

  componentDidUpdate(prevProps, prevState) {
    // Login's reading-options fetch landed after this page mounted.
    if (
      !prevProps.savedReadingOptions &&
      this.props.savedReadingOptions &&
      !this.readingOptionsApplied
    ) {
      this.applyReadingOptions(this.props.savedReadingOptions);
    }

    // Re-apply highlights whenever the highlight list changes or whenever the
    // underlying text/DOM could have changed (new grade data, reading
    // options all re-render the highlighted containers).
    if (
      prevState.highlights !== this.state.highlights ||
      prevState.grading !== this.state.grading ||
      prevState.readingFontSize !== this.state.readingFontSize ||
      prevState.readingFontFamily !== this.state.readingFontFamily ||
      prevState.readingLineHeight !== this.state.readingLineHeight ||
      prevState.readingLetterSpacing !== this.state.readingLetterSpacing ||
      prevState.readingColorScheme !== this.state.readingColorScheme
    ) {
      this.applyHighlightsToDom();
    }
  }

  componentWillUnmount() {
    if (this.highlightApiSupported) {
      CSS.highlights.delete(this.HIGHLIGHT_REGISTRY_KEY);
    }

    // --- Copy protection ---
    document.removeEventListener("contextmenu", this.disableContextMenu);
    document.removeEventListener("keydown", this.disableCopyCut);
    document.removeEventListener("copy", this.disableCopyEvent);

    document.removeEventListener("selectionchange", this.handleSelectionChange);
    if (this.selectionSettleTimer) {
      clearTimeout(this.selectionSettleTimer);
    }
  }

  // --- Copy protection ---
  disableContextMenu = (event) => event.preventDefault();

  disableCopyCut = (event) => {
    if (
      (event.ctrlKey || event.metaKey) &&
      (event.key === "c" || event.key === "x")
    ) {
      event.preventDefault();
    }
  };

  disableCopyEvent = (event) => {
    event.preventDefault();
  };

  fetchReviewLater = () => {
    let caseId;
    if (this.props.caseGrades) {
      caseId = this.props.caseGrades;
    } else {
      caseId = this.props.selectedCase;
    }
    this.setState({ reviewLaterLoading: true });
    fetch(`${this.props.route}/reviewlater.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
        caseId: caseId,
        marked: !this.state.reviewLater,
      }),
    })
      .then((response) => {
        this.setState({ reviewLaterLoading: false });
        //Attempt sending logs
        fetchSubmitLogs(this.props.userProfile, this.props.userData);

        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((response) => {
        this.reviewLaterToggle();
      })
      .catch((error) => {
        this.setState({ reviewLaterLoading: false });
        // if (error.toString().includes('SyntaxError: Unexpected token U in JSON at position 1') || error.toString().includes('SyntaxError: JSON Parse error: Expected \'}\'')) {
        // 	this.props.setAuthenticationError()
        // }
        console.log(error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchReviewLater",
        );
      });
  };

  reviewLaterToggle = () => {
    this.setState({ reviewLater: !this.state.reviewLater }, () => {
      this.props.updateReviewLater();
    });
  };

  getDateSuffix = (day) => {
    if (day === 1 || day === 21 || day === 31) {
      return "st";
    } else if (day === 2 || day === 22) {
      return "nd";
    } else if (day === 3 || day === 23) {
      return "rd";
    } else {
      return "th";
    }
  };

  fetchRetrieveCaseGrade = async (id) => {
    await fetch(`${this.props.route}/retreivecasegrade.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        CustomerGradeId: id,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((data) => {
        //Attempt sending logs
        fetchSubmitLogs(this.props.userProfile, this.props.userData);

        data = JSON.parse(data);
        console.log(data);
        // console.log(data.pgolist.pgolist[2].GradeOut[0].OrderName)

        // Get caseData from the unfiltered case list
        let caseData = this.props.unfilteredCaseList.filter(
          (tempCase) => tempCase.ID === this.props.selectedCase,
        )[0];

        this.setState({
          selectedCase: id,
          grading: data,
          highYield: data.HighYieldFlag,
          selectedCaseData: caseData,
          caseCompletionDate: data.CaseCompletionDate,
        });

        // data = JSON.parse(data)

        // // Get caseData from the unfiltered case list
        // let caseData = this.props.unfilteredCaseList.filter(tempCase => tempCase.ID === this.props.selectedCase)[0]

        // console.log(data)

        // // sort by GradeCategory
        // data.GradeFeedback.GradeOut.sort((a, b) => {
        //     if (a.GradeCategory < b.GradeCategory) {
        //         return -1
        //     } else if (a.GradeCategory > b.GradeCategory) {
        //         return 1
        //     } else {
        //         return 0
        //     }
        // })
        // data.GradeFeedback.GradeOut = data.GradeFeedback.GradeOut.filter(grade => grade.GradeCategory !== "")

        // for(let i = 0; i < data.GradeFeedback.GradeOut.length; i++) {
        //     if (data.GradeFeedback.GradeOut[i].GradeColor.includes('Correct - Green')) {
        //         data.GradeFeedback.GradeOut[i].Correct = true
        //     } else {
        //         data.GradeFeedback.GradeOut[i].Correct = false
        //     }
        // }

        // for (let i = 0; i < data.GradeFeedback.ActionLogList.length; ++i) {
        //     if (data.GradeFeedback.ActionLogList[i].EventName.includes('State Changed to:')) {
        //         data.GradeFeedback.ActionLogList.splice(i, 1);
        //         i--;
        //     }
        // }

        // this.setState({
        // 	selectedCase: id,
        //     selectedCaseData: caseData,
        //     caseCompletionDate: this.formatCompletionDate(data.CaseCompletionDate),
        //     caseGradeData: data,
        // 	grading: data,
        // 	highYield: data.HighYieldFlag
        // });
      })
      .catch((error) => {
        // if (error.toString().includes('SyntaxError: Unexpected token U in JSON at position 1') || error.toString().includes('SyntaxError: JSON Parse error: Expected \'}\'')) {
        // 	this.props.setAuthenticationError()
        // }
        console.log("error", error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchRetrieveCaseGrade",
        );
      });
  };

  fetchPeekCaseGrade = () => {
    let caseId = this.props.selectedCase;
    fetch(`${this.props.route}/peekatgrading.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
        caseId: caseId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((data) => {
        if (
          data.includes(
            "The customer has already done this case. The customer should use View Grades instead.",
          )
        ) {
          return;
        }
        data = JSON.parse(data);
        console.log(data);
        let grading = {
          GradeFeedback: data,
        };

        let caseData = this.props.unfilteredCaseList.filter(
          (tempCase) => tempCase.ID === this.props.selectedCase,
        )[0];

        this.setState({
          caseCompletionDate: data.CompletionDate,
          selectedCase: caseId,
          grading,
          selectedCaseData: caseData,
        });
      })
      .catch((error) => {
        console.log("error", error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchPeekCaseGrade",
        );
      });
  };

  fetchViewCaseGrade = () => {
    let caseId;
    if (this.props.caseGrades) {
      caseId = this.props.caseGrades;
    } else {
      caseId = this.props.selectedCase;
    }
    fetch(`${this.props.route}/viewcasegrade.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
        caseId: caseId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((response) => {
        // console.log(JSON.parse(response))

        //Attempt sending logs
        fetchSubmitLogs(this.props.userProfile, this.props.userData);

        let data = response;
        // reverse order of array
        let array = JSON.parse(data).vcgo;
        array.reverse();
        let months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

        let caseArray = []; // only display the cases that are of the case selected
        // format dates
        for (let i = 0; i < array.length; i++) {
          let date = new Date(`${array[i].CaseCompletionDate}Z`);

          let minutes = date.getUTCMinutes();
          if (minutes.toString().length === 1) {
            minutes = "0" + minutes;
          }

          array[i].CaseCompletionDate =
            months[date.getUTCMonth()] +
            " " +
            date.getUTCDate() +
            ", " +
            date.getUTCFullYear() +
            ", " +
            date.getUTCHours() +
            ":" +
            minutes;

          if (
            array[i].CaseId === caseId &&
            array[i].CaseCompletionDate !== "January 1, 1, 0:00"
          ) {
            caseArray.push(array[i]);
          }
        }

        let newCaseArray = [];
        if (this.props.userProfile.selectedTimeZone !== "-7") {
          const MONTHS = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          let hoursAdjustment =
            Number(this.props.userProfile.selectedTimeZone) + 7;
          caseArray.forEach((value, index) => {
            let date = new Date(value.CaseCompletionDate);
            date.setTime(date.getTime() + hoursAdjustment * 60 * 60 * 1000);
            let newCaseArrayValue = value;
            let dateString = `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}, ${date.getHours()}:${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;
            newCaseArrayValue.CaseCompletionDate = dateString;
            newCaseArray.push(newCaseArrayValue);
          });
        } else {
          newCaseArray = [...caseArray];
        }

        // sort newCaseArray by CaseCompletionDate
        newCaseArray.sort((a, b) => {
          return (
            new Date(b.CaseCompletionDate) - new Date(a.CaseCompletionDate)
          );
        });

        // if !this.props.grading fetch data for most recent case
        if (!this.props.grading) {
          this.fetchRetrieveCaseGrade(newCaseArray[0].CustomerGradeId);
        }

        this.setState({
          previousCompletions: newCaseArray,
          selectedCase: newCaseArray[0].CustomerGradeId,
        });
      })
      .catch((error) => {
        // if (error.toString().includes('SyntaxError: Unexpected token U in JSON at position 1') || error.toString().includes('SyntaxError: JSON Parse error: Expected \'}\'')) {
        // 	this.props.setAuthenticationError()
        // }
        console.log(error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchViewCaseGrade",
        );
      });
  };

  markHighYieldHandler = () => {
    let caseId;
    if (this.props.caseGrades) {
      caseId = this.props.caseGrades;
    } else {
      caseId = this.props.selectedCase;
    }
    this.setState(
      { highYield: !this.state.highYield, highYieldLoading: true },
      () => {
        fetch(`${this.props.route}/highyield.webapi`, {
          method: "POST",
          headers: {
            Token: this.props.userData.Token,
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            customerid: this.props.userData.CustomerId,
            caseid: caseId,
            markhighyield: this.state.highYield,
            unmarkhighyield: !this.state.highYield,
          }),
        })
          .then((response) => {
            this.setState({ highYieldLoading: false });
            //Attempt sending logs
            fetchSubmitLogs(this.props.userProfile, this.props.userData);

            if (response.status === 401) {
              this.props.setAuthenticationError();
              throw new Error("Authentication Error");
            } else {
              return response.text();
            }
          })
          .then((response) => {})
          .catch((error) => {
            this.setState({
              highYield: !this.state.highYield,
              highYieldLoading: false,
            });
            logFetchError(
              error,
              this.props.userProfile,
              this.props.userData,
              "markHighYieldHandler",
            );
          });
      },
    );
  };

  highYieldHelpHandler = (e) => {
    e.stopPropagation();
    let confirmationPopupOptions = {
      title: `High Yield`,
      description: `If you think this case has a good chance to show up on the COMLEX Level 3 exam, you can mark it as High Yield. This helps other users know which cases to study.`,
      confirmFunction: async () => {
        this.props.closeConfirmationPopup();
      },
      children: null,
      closePopup: () => {
        this.props.closeConfirmationPopup();
      },
      continueOnly: true,
    };
    this.props.displayConfirmationPopup(confirmationPopupOptions);
  };

  // ============================================================
  // Feedback button / modal
  // ============================================================

  submitFeedback = () => {
    if (!this.state.feedbackText.trim()) {
      return;
    }

    this.setState({ feedbackLoading: true, feedbackError: null });

    const caseId = this.state.selectedCaseData?.ID ?? null;
    const caseDiagnosis = this.props.selectedCaseDiagnosis ?? null;

    const feedbackPayload = {
      customerId: this.props.userData.CustomerId,
      feedback: this.state.feedbackText,
      ...(caseId !== null && { caseId }),
      ...(caseDiagnosis !== null && { caseDiagnosis }),
    };

    fetch(`${this.props.route}/feedback.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify(feedbackPayload),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        }
        return response.text();
      })
      .then((response) => {
        this.setState({
          feedbackLoading: false,
          feedbackSubmitted: true,
          feedbackText: "",
        });
        setTimeout(() => {
          this.setState({
            showFeedbackModal: false,
            feedbackSubmitted: false,
          });
        }, 2000);
      })
      .catch((error) => {
        this.setState({
          feedbackLoading: false,
          feedbackError: "Failed to submit feedback. Please try again.",
        });
        console.log(error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "submitFeedback",
        );
      });
  };

  closeFeedbackModal = () => {
    this.setState({
      showFeedbackModal: false,
      feedbackText: "",
      feedbackSubmitted: false,
      feedbackError: null,
    });
  };

  openReportCardModal = () => {
    this.setState({ showReportCardModal: true });
  };

  closeReportCardModal = () => {
    this.setState({ showReportCardModal: false });
  };

  // ============================================================
  // Try Case Again
  // ============================================================

  beginCaseHandler = async (selectedCase) => {
    if (selectedCase) {
      for (let i = 0; i < this.props.unfilteredCaseList.length; i++) {
        if (this.props.unfilteredCaseList[i].ID === selectedCase) {
          this.setState({ loadingStartCase: true });
          await this.props
            .fetchStartCase(
              this.props.unfilteredCaseList[i],
              this.incompleteStartDisplayHandler,
            )
            .then(() => {
              this.setState({ loadingStartCase: false });
            })
            .catch(() => {
              this.setState({ loadingStartCase: false });
            });
        }
      }
    }
  };

  // ============================================================
  // Reading options
  // ============================================================

  fetchReadingOptions = () => {
    fetch(`${this.props.route}/getsavedreadingoptions.webapi`, {
      method: "POST",
      headers: {
        Token: this.props.userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        customerId: this.props.userData.CustomerId,
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          this.props.setAuthenticationError();
          throw new Error("Authentication Error");
        } else {
          return response.text();
        }
      })
      .then((data) => {
        data = JSON.parse(data);
        this.applyReadingOptions(data);
      })
      .catch((error) => {
        console.log("error", error);
        logFetchError(
          error,
          this.props.userProfile,
          this.props.userData,
          "fetchReadingOptions",
        );
      });
  };

  applyReadingOptions = (data) => {
    if (!data || typeof data !== "object") return;
    this.readingOptionsApplied = true;
    this.setState({
      ...(data.readingFontSize && {
        readingFontSize: data.readingFontSize,
      }),
      ...(data.readingFontFamily && {
        readingFontFamily: data.readingFontFamily,
      }),
      ...(data.readingLineHeight && {
        readingLineHeight: data.readingLineHeight,
      }),
      ...(data.readingLetterSpacing && {
        readingLetterSpacing: data.readingLetterSpacing,
      }),
      ...(data.readingColorScheme && {
        readingColorScheme: data.readingColorScheme,
      }),
    });
  };

  saveReadingOptions = async () => {
    const readingOptions = {
      readingFontSize: this.state.readingFontSize,
      readingFontFamily: this.state.readingFontFamily,
      readingLineHeight: this.state.readingLineHeight,
      readingLetterSpacing: this.state.readingLetterSpacing,
      readingColorScheme: this.state.readingColorScheme,
    };

    // Through App: merged into the full saved blob, so the simulation
    // preferences saved alongside these aren't wiped.
    if (this.props.saveReadingOptions) {
      return this.props.saveReadingOptions(readingOptions, {
        immediate: true,
      });
    }

    try {
      const response = await fetch(
        `${this.props.route}/savereadingoptions.webapi`,
        {
          method: "POST",
          headers: {
            Token: this.props.userData.Token,
            "Content-Type": "text/plain",
          },
          body: JSON.stringify({
            ...(this.props.savedReadingOptions || {}),
            customerId: this.props.userData.CustomerId,
            ...readingOptions,
          }),
        },
      );

      if (response.status === 401) {
        this.props.setAuthenticationError();
        throw new Error("Authentication Error");
      }
    } catch (error) {
      console.log("error", error);
      logFetchError(
        error,
        this.props.userProfile,
        this.props.userData,
        "savereadingoptions",
      );
    }
  };

  getReadingStyle = (verdict = "neutral") => {
    const fontSizeMap = {
      small: "13px",
      medium: "15px",
      large: "17px",
      xlarge: "20px",
    };
    const fontFamilyMap = {
      sans: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      serif: "Georgia, 'Times New Roman', serif",
      mono: "'Courier New', Courier, monospace",
    };
    const lineHeightMap = { compact: "1.4", normal: "1.7", relaxed: "2.1" };
    const letterSpacingMap = { normal: "0px", wide: "0.04em" };

    // Color scheme overrides keyed by [scheme][verdict] → { background, color }
    const colorSchemes = {
      default: {
        neutral: { color: "var(--new-text-color)" },
      },
      mono: {
        correct: { backgroundColor: "#f0f0f0", color: "#1a1a1a" },
        incorrect: { backgroundColor: "#8a8a8a", color: "#f5f5f5" },
        neutral: { backgroundColor: "#e0e0e0", color: "#1a1a1a" },
      },
      sepia: {
        correct: { backgroundColor: "#f0e8cf", color: "#3b2f14" },
        incorrect: { backgroundColor: "#b89a70", color: "#2a1f0a" },
        neutral: { backgroundColor: "#ede5cc", color: "#3b2f14" },
      },
      cool: {
        correct: { backgroundColor: "#e8f4fc", color: "#0d2a3a" },
        incorrect: { backgroundColor: "#7aafd4", color: "#0d1e2e" },
        neutral: { backgroundColor: "#daeaf7", color: "#0d2a3a" },
      },
      highcontrast: {
        correct: { backgroundColor: "#003300", color: "#ccffcc" },
        incorrect: { backgroundColor: "#330000", color: "#ffcccc" },
        neutral: { backgroundColor: "#00134d", color: "#cce0ff" },
      },
    };

    const colorOverride =
      colorSchemes[this.state.readingColorScheme]?.[verdict] ?? {};

    return {
      fontSize: fontSizeMap[this.state.readingFontSize],
      fontFamily: fontFamilyMap[this.state.readingFontFamily],
      lineHeight: lineHeightMap[this.state.readingLineHeight],
      letterSpacing: letterSpacingMap[this.state.readingLetterSpacing],
      ...colorOverride,
    };
  };

  // ============================================================
  // Highlighter
  // ============================================================

  toggleHighlighter = () => {
    this.setState((s) => ({ highlighterActive: !s.highlighterActive }));
  };

  clearAllHighlights = () => {
    this.setState({ highlights: [] });
  };

  // Serializable payload, ready to POST to an API
  getHighlightsPayload = () => {
    return {
      customerId: this.props.userData.CustomerId,
      caseId:
        this.state.selectedCaseData?.ID ??
        this.props.caseGrades ??
        this.props.selectedCase ??
        null,
      highlights: this.state.highlights,
    };
  };

  // Restore highlights previously produced by getHighlightsPayload().highlights
  loadHighlights = (highlights) => {
    this.setState({
      highlights: Array.isArray(highlights) ? highlights : [],
    });
  };

  // --- DOM helpers -------------------------------------------

  findHighlightContainer = (containerKey) => {
    const root = this.pageRef.current || document;
    const containers = root.querySelectorAll(
      "[data-highlight-container='true']",
    );
    for (let i = 0; i < containers.length; i++) {
      if (containers[i].dataset.highlightKey === containerKey) {
        return containers[i];
      }
    }
    return null;
  };

  getTextNodesIn = (container) => {
    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT,
      null,
    );
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) {
      nodes.push(node);
    }
    return nodes;
  };

  // Character offset of (node, offset) within container.textContent
  getOffsetWithin = (container, node, offset) => {
    try {
      const range = document.createRange();
      range.selectNodeContents(container);
      range.setEnd(node, offset);
      return range.toString().length;
    } catch (error) {
      return null;
    }
  };

  // Rebuild a Range from stored character offsets
  createRangeFromOffsets = (container, start, end) => {
    const textNodes = this.getTextNodesIn(container);
    let charCount = 0;
    let startNode = null;
    let startOffset = 0;
    let endNode = null;
    let endOffset = 0;

    for (let i = 0; i < textNodes.length; i++) {
      const node = textNodes[i];
      const length = node.textContent.length;
      if (startNode === null && start <= charCount + length) {
        startNode = node;
        startOffset = start - charCount;
      }
      if (startNode !== null && end <= charCount + length) {
        endNode = node;
        endOffset = end - charCount;
        break;
      }
      charCount += length;
    }

    if (!startNode || !endNode) {
      return null;
    }

    try {
      const range = document.createRange();
      range.setStart(startNode, startOffset);
      range.setEnd(endNode, endOffset);
      return range;
    } catch (error) {
      return null;
    }
  };

  // --- Applying highlights to the DOM ------------------------

  applyHighlightsToDom = () => {
    if (this.highlightApiSupported) {
      CSS.highlights.delete(this.HIGHLIGHT_REGISTRY_KEY);
    } else {
      this.clearHighlightMarks();
    }

    if (this.state.highlights.length === 0) {
      return;
    }

    const resolvedRanges = [];
    this.state.highlights.forEach((highlight) => {
      const container = this.findHighlightContainer(highlight.containerKey);
      if (!container) {
        return;
      }

      let range = this.createRangeFromOffsets(
        container,
        highlight.startOffset,
        highlight.endOffset,
      );

      // If the text at the stored offsets no longer matches (e.g. the
      // container's text changed between save and load), try to re-anchor
      // by searching for the stored text.
      if (!range || range.toString() !== highlight.text) {
        const fullText = container.textContent;
        const index = fullText.indexOf(highlight.text);
        if (index === -1) {
          return; // Can't place this highlight in the current DOM — skip it
        }
        range = this.createRangeFromOffsets(
          container,
          index,
          index + highlight.text.length,
        );
        if (!range) {
          return;
        }
      }

      resolvedRanges.push({ range, id: highlight.id });
    });

    if (resolvedRanges.length === 0) {
      return;
    }

    if (this.highlightApiSupported) {
      CSS.highlights.set(
        this.HIGHLIGHT_REGISTRY_KEY,
        new window.Highlight(...resolvedRanges.map((entry) => entry.range)),
      );
    } else {
      // Fallback: wrap ranges in <mark> elements. Process in reverse document
      // order so earlier offsets aren't invalidated by DOM splits.
      resolvedRanges
        .slice()
        .reverse()
        .forEach((entry) => this.wrapRangeInMarks(entry.range, entry.id));
    }
  };

  wrapRangeInMarks = (range, highlightId) => {
    const root =
      range.commonAncestorContainer.nodeType === Node.TEXT_NODE
        ? range.commonAncestorContainer.parentNode
        : range.commonAncestorContainer;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const intersecting = [];
    let node;
    while ((node = walker.nextNode())) {
      if (range.intersectsNode(node)) {
        intersecting.push(node);
      }
    }

    // Reverse order so splitting text nodes doesn't shift earlier boundaries
    intersecting.reverse().forEach((textNode) => {
      const start = textNode === range.startContainer ? range.startOffset : 0;
      const end =
        textNode === range.endContainer
          ? range.endOffset
          : textNode.textContent.length;
      if (end <= start) {
        return;
      }

      let nodeToWrap = textNode;
      if (start > 0) {
        nodeToWrap = textNode.splitText(start);
      }
      if (end - start < nodeToWrap.textContent.length) {
        nodeToWrap.splitText(end - start);
      }

      const mark = document.createElement("mark");
      mark.className = "newGradingTextHighlight";
      mark.dataset.highlightId = highlightId;
      nodeToWrap.parentNode.insertBefore(mark, nodeToWrap);
      mark.appendChild(nodeToWrap);
    });
  };

  clearHighlightMarks = () => {
    const root = this.pageRef.current || document;
    root.querySelectorAll("mark.newGradingTextHighlight").forEach((mark) => {
      const parent = mark.parentNode;
      while (mark.firstChild) {
        parent.insertBefore(mark.firstChild, mark);
      }
      parent.removeChild(mark);
      parent.normalize();
    });
  };

  // --- Selection handling -------------------------------------

  // Extracts { clientX, clientY } from either a MouseEvent or a TouchEvent
  // (touchend events carry their coordinates on changedTouches, not on the
  // event itself).
  getEventPoint = (event) => {
    if (event.changedTouches && event.changedTouches.length > 0) {
      return {
        clientX: event.changedTouches[0].clientX,
        clientY: event.changedTouches[0].clientY,
      };
    }
    return { clientX: event.clientX, clientY: event.clientY };
  };

  // Turns the current, non-collapsed window selection into a stored
  // highlight (if it falls inside a highlight-able container). Shared by the
  // desktop mouseup path and the mobile selectionchange path.
  commitSelectionAsHighlight = (selection) => {
    const rawRange = selection.getRangeAt(0);
    const startElement =
      rawRange.startContainer.nodeType === Node.TEXT_NODE
        ? rawRange.startContainer.parentElement
        : rawRange.startContainer;
    const container =
      startElement &&
      startElement.closest &&
      startElement.closest("[data-highlight-container='true']");

    // Only text inside the designated containers can be highlighted
    if (!container) {
      selection.removeAllRanges();
      return;
    }

    // Clamp selections that run past the end of the container
    const range = rawRange.cloneRange();
    if (!container.contains(range.endContainer)) {
      range.setEnd(container, container.childNodes.length);
    }

    const startOffset = this.getOffsetWithin(
      container,
      range.startContainer,
      range.startOffset,
    );
    const endOffset = this.getOffsetWithin(
      container,
      range.endContainer,
      range.endOffset,
    );

    if (
      startOffset === null ||
      endOffset === null ||
      endOffset <= startOffset
    ) {
      selection.removeAllRanges();
      return;
    }

    const text = range.toString();
    if (!text.trim()) {
      selection.removeAllRanges();
      return;
    }

    const highlight = {
      id: `hl-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      containerType: container.dataset.highlightType,
      containerKey: container.dataset.highlightKey,
      startOffset,
      endOffset,
      text,
      createdAt: new Date().toISOString(),
    };

    selection.removeAllRanges();
    this.setState((s) => ({ highlights: [...s.highlights, highlight] }));
  };

  // Desktop path: a real mouseup fires as soon as the mouse button is
  // released, so we can react immediately.
  handleHighlightMouseUp = (event) => {
    if (!this.state.highlighterActive) {
      return;
    }

    const selection = window.getSelection();
    if (!selection) {
      return;
    }

    // A plain click (no selection) on an existing highlight removes it
    if (selection.isCollapsed || selection.rangeCount === 0) {
      this.removeHighlightAtPoint(event);
      return;
    }

    this.commitSelectionAsHighlight(selection);
  };

  // Mobile path: dragging the native selection handles doesn't reliably
  // bubble mouseup/touchend up to our container (the drag happens on
  // browser/OS-owned UI, not our DOM), but "selectionchange" always fires as
  // the Selection object is updated. We debounce it so we only commit once
  // the selection has stopped changing for a moment (i.e. the user has
  // finished adjusting the handles) instead of firing on every intermediate
  // character the drag passes over.
  handleSelectionChange = () => {
    if (!this.state.highlighterActive) {
      return;
    }

    if (this.selectionSettleTimer) {
      clearTimeout(this.selectionSettleTimer);
    }

    this.selectionSettleTimer = setTimeout(() => {
      const selection = window.getSelection();
      if (!selection || selection.isCollapsed || selection.rangeCount === 0) {
        return;
      }
      this.commitSelectionAsHighlight(selection);
    }, 300);
  };

  // Mobile path for tap-to-remove: touchend does fire reliably for simple
  // taps (as opposed to handle-drags), so it's a safe way to catch "the user
  // tapped an existing highlight to delete it" on touch devices.
  handleHighlightTouchEnd = (event) => {
    if (!this.state.highlighterActive) {
      return;
    }

    const selection = window.getSelection();
    if (selection && !selection.isCollapsed && selection.rangeCount > 0) {
      return;
    }

    this.removeHighlightAtPoint(event);
  };

  removeHighlightAtPoint = (event) => {
    // Fallback (<mark>) path: the tap/click target is the mark itself
    const markElement =
      event.target &&
      event.target.closest &&
      event.target.closest("mark.newGradingTextHighlight");
    if (markElement) {
      const id = markElement.dataset.highlightId;
      this.setState((s) => ({
        highlights: s.highlights.filter((h) => h.id !== id),
      }));
      return;
    }

    // CSS Custom Highlight API path: resolve the caret position under the
    // tap/click and match it against stored highlight ranges
    const container =
      event.target &&
      event.target.closest &&
      event.target.closest("[data-highlight-container='true']");
    if (!container) {
      return;
    }

    const { clientX, clientY } = this.getEventPoint(event);

    let node = null;
    let offset = 0;
    if (document.caretPositionFromPoint) {
      const position = document.caretPositionFromPoint(clientX, clientY);
      if (position) {
        node = position.offsetNode;
        offset = position.offset;
      }
    } else if (document.caretRangeFromPoint) {
      const caretRange = document.caretRangeFromPoint(clientX, clientY);
      if (caretRange) {
        node = caretRange.startContainer;
        offset = caretRange.startOffset;
      }
    }

    if (!node || !container.contains(node)) {
      return;
    }

    const globalOffset = this.getOffsetWithin(container, node, offset);
    if (globalOffset === null) {
      return;
    }

    const containerKey = container.dataset.highlightKey;
    const match = this.state.highlights.find(
      (h) =>
        h.containerKey === containerKey &&
        globalOffset >= h.startOffset &&
        globalOffset <= h.endOffset,
    );
    if (match) {
      this.setState((s) => ({
        highlights: s.highlights.filter((h) => h.id !== match.id),
      }));
    }
  };

  getMultipleChoiceOption = (optionIndex, questionId) => {
    let answer;
    this.state.grading.ao.forEach((answerValue, answerIndex) => {
      if (answerValue.ANSWERID === optionIndex) {
        answer = answerValue.ANSWER;
      }
    });
    return answer;
  };

  renderPointsRing = (pointsEarned, pointsPossible, pgoValue) => {
    const earned = Number(pointsEarned) || 0;
    const possible = Number(pointsPossible) || 0;
    const percent =
      possible > 0 ? Math.max(0, Math.min(1, earned / possible)) : 0;

    const radius = 20;
    const strokeWidth = 5;
    const circumference = 2 * Math.PI * radius;
    const dashOffset = circumference * (1 - percent);

    const formatPoints = (value) =>
      Number.isInteger(value) ? value : Math.round(value * 10) / 10;

    if (
      !(
        !this.state.grading.pgolist.TotalPointsEarned &&
        !this.state.grading.pgolist.TotalPointsPossible
      )
    ) {
      return (
        <div className="pointsRing">
          <svg className="pointsRingSvg" viewBox="0 0 50 50">
            <circle
              className="pointsRingTrack"
              cx="25"
              cy="25"
              r={radius}
              strokeWidth={strokeWidth}
            />
            <circle
              className="pointsRingProgress"
              cx="25"
              cy="25"
              r={radius}
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={dashOffset}
            />
          </svg>
          <div className="pointsRingLabel">
            <span className="pointsRingEarned">{formatPoints(earned)}</span>
            <span className="pointsRingPossible">
              /{formatPoints(possible)}
            </span>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  };

  render() {
    return (
      <GamificationToastWrapper messages={this.props.gamificationMessages}>
        <div
          className={`newGradingPageWrapper${this.state.highlighterActive ? " newGradingHighlighterActive" : ""}`}
          ref={this.pageRef}
          onMouseUp={this.handleHighlightMouseUp}
          onTouchEnd={this.handleHighlightTouchEnd}
        >
          <style>{`
                  ::highlight(${this.HIGHLIGHT_REGISTRY_KEY}) {
                      background-color: rgba(255, 214, 10, 0.55);
                  }
                  mark.newGradingTextHighlight {
                      background-color: rgba(255, 214, 10, 0.55);
                      color: inherit;
                      padding: 0;
                  }
                  .newGradingHighlighterActive [data-highlight-container='true'] {
                      cursor: text;
                  }
                  .newGradingHighlighterActive [data-highlight-container='true'] ::selection {
                      background-color: rgba(255, 214, 10, 0.45);
                  }
                  `}</style>
          <nav className="newGradingNavbar">
            <img className="newGradingLogo" alt="CCS Cases Logo" src={Logo} />
          </nav>
          <AnimatePresence exitBeforeEnter>
            {!this.state.grading && (
              <motion.div
                className="newGradingLoaderContainer"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={
                  this.props.animationsDisabled ? false : { y: 0, opacity: 1 }
                }
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key="newGradingLoaderContainer"
              >
                <MDSpinner size={60} singleColor={this.props.primaryColor} />
                <p className="newGradingLoaderText">Loading Grades</p>
              </motion.div>
            )}
            {this.state.grading && (
              <motion.div
                className="newGradingBackWrapper"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key="newGradingBackWrapper"
              >
                <button
                  className="tertiaryButton newGradingBackButton"
                  onClick={async () => {
                    await this.saveReadingOptions();
                    this.props.closeGrading();
                  }}
                >
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    className="newGradingBackIcon"
                  />
                  Back To Case List
                </button>
                {this.props.gradingMode !== "peek" && this.state.grading && (
                  <div
                    className="newGradingCheckboxContainer"
                    onClick={this.markHighYieldHandler}
                    style={{
                      gridTemplateColumns: "30px auto auto",
                      paddingRight: "10px",
                    }}
                  >
                    <div className="newGradingCheckbox">
                      {this.state.highYield && (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="newGradingCheckboxIcon"
                        />
                      )}
                    </div>
                    <p className="newGradingCheckboxText">High Yield</p>
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      className="highYieldMoreInfoButton"
                      onClick={this.highYieldHelpHandler}
                    />
                    {this.state.highYieldLoading && (
                      <div className="highYieldLoadingContainer">
                        <MDSpinner size={35} singleColor={"#fff"} />
                      </div>
                    )}
                  </div>
                )}
                <div
                  className="newGradingCheckboxContainer"
                  onClick={this.fetchReviewLater}
                  style={{ gridTemplateColumns: "30px auto" }}
                >
                  <div className="newGradingCheckbox">
                    {this.state.reviewLater && (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="newGradingCheckboxIcon"
                      />
                    )}
                  </div>
                  <p className="newGradingCheckboxText">Review Later</p>
                  {this.state.reviewLaterLoading && (
                    <div className="highYieldLoadingContainer">
                      <MDSpinner size={30} singleColor={"#fff"} />
                    </div>
                  )}
                </div>
              </motion.div>
            )}
            {this.state.grading && (
              <motion.div
                className="newGradingCaseTitleContainer"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key="newGradingCaseTitleContainer"
              >
                <div className="newGradingCaseNumberContainer">
                  <h1 className="newGradingCaseNumber">
                    {this.state.selectedCaseData.ID}
                  </h1>
                </div>
                <div className="newGradingCaseTitleWrapper">
                  <h2 className="newGradingCaseTitle">
                    {this.state.selectedCaseData.TITLE} -{" "}
                    {this.state.selectedCaseData.CASECATEGORY}
                  </h2>
                  <h3 className="newGradingCaseCompletionDate">
                    Completed:{" "}
                    {formatDateString(
                      this.state.caseCompletionDate,
                      this.props.userData.TimeZone,
                    )}
                    ,{" "}
                    {formatTimeString(
                      this.state.caseCompletionDate,
                      this.props.userData.TimeZone,
                    )}
                  </h3>
                </div>
                <div className="grading-button-block">
                  <div className="highlightingContainer">
                    <button
                      className="tertiaryButton newGradingBackButton"
                      onClick={this.toggleHighlighter}
                      title={
                        this.state.highlighterActive
                          ? "Highlighter on — select text to highlight it, click a highlight to remove it"
                          : "Turn on the highlighter"
                      }
                      style={
                        this.state.highlighterActive
                          ? {
                              boxShadow:
                                "0 0 0 2px rgba(255, 214, 10, 0.9) inset",
                            }
                          : {}
                      }
                    >
                      <FontAwesomeIcon
                        icon={faHighlighter}
                        className="newGradingBackIcon"
                      />
                      {this.state.highlighterActive
                        ? "Highlighter On"
                        : "Highlighter"}
                      {this.state.highlights.length > 0 &&
                        ` (${this.state.highlights.length})`}
                    </button>
                    {this.state.highlights.length > 0 && (
                      <button
                        className="tertiaryButton newGradingBackButton"
                        onClick={this.clearAllHighlights}
                        title="Remove all highlights"
                      >
                        <FontAwesomeIcon
                          icon={faEraser}
                          className="newGradingBackIcon"
                        />
                        Clear Highlights
                      </button>
                    )}
                  </div>
                  {this.props.gradingMode !== "peek" && (
                    <button
                      className="tertiaryButton newGradingBackButton"
                      onClick={() =>
                        this.beginCaseHandler(this.props.selectedCase)
                      }
                      disabled={this.state.loadingStartCase}
                      style={{ opacity: this.state.loadingStartCase ? 0.6 : 1 }}
                    >
                      <FontAwesomeIcon
                        icon={faArrowRotateLeft}
                        className="newGradingBackIcon"
                      />
                      Try Case Again
                      {this.state.loadingStartCase && (
                        <div className="highYieldLoadingContainer">
                          <MDSpinner size={35} singleColor={"#fff"} />
                        </div>
                      )}
                    </button>
                  )}
                  {this.props.gradingMode !== "peek" &&
                    !this.props.hideFeedbackInGrading && (
                      <button
                        className="newGradingViewPreviousButton tertiaryButton"
                        onClick={() =>
                          this.setState({ showFeedbackModal: true })
                        }
                      >
                        Feedback
                      </button>
                    )}
                  {this.props.gradingMode !== "peek" && (
                    <button
                      className="newGradingViewPreviousButton tertiaryButton"
                      onClick={() =>
                        this.setState({ viewPreviousCompletions: true })
                      }
                    >
                      View Previous Completions
                    </button>
                  )}
                  <div className="readingOptionsWrapper">
                    <button
                      className="newGradingViewPreviousButton tertiaryButton readingOptionsToggle"
                      onClick={() =>
                        this.setState((s) => ({
                          showReadingOptions: !s.showReadingOptions,
                        }))
                      }
                    >
                      <span className="readingOptionsIcon">Aa</span>
                      <span className="readingOptionsText">
                        Reading Options
                      </span>
                    </button>
                    {this.state.showReadingOptions && (
                      <>
                        <div
                          className="readingOptionsBackdrop"
                          onClick={() =>
                            this.setState({ showReadingOptions: false })
                          }
                        />
                        <div
                          className="readingOptionsPanel"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="readingOptionsSection">
                            <span className="readingOptionsLabel">
                              Font Size
                            </span>
                            <div className="readingOptionsRow">
                              {[
                                { key: "small", label: "S" },
                                { key: "medium", label: "M" },
                                { key: "large", label: "L" },
                                { key: "xlarge", label: "XL" },
                              ].map(({ key, label }) => (
                                <button
                                  key={key}
                                  className={`readingOptionChip ${this.state.readingFontSize === key ? "readingOptionChipActive" : ""}`}
                                  onClick={() =>
                                    this.setState({ readingFontSize: key })
                                  }
                                >
                                  {label}
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="readingOptionsSection">
                            <span className="readingOptionsLabel">
                              Typeface
                            </span>
                            <div className="readingOptionsRow">
                              {[
                                { key: "sans", label: "Sans" },
                                { key: "serif", label: "Serif" },
                                { key: "mono", label: "Mono" },
                              ].map(({ key, label }) => (
                                <button
                                  key={key}
                                  className={`readingOptionChip ${this.state.readingFontFamily === key ? "readingOptionChipActive" : ""}`}
                                  onClick={() =>
                                    this.setState({ readingFontFamily: key })
                                  }
                                >
                                  {label}
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="readingOptionsSection">
                            <span className="readingOptionsLabel">
                              Line Spacing
                            </span>
                            <div className="readingOptionsRow">
                              {[
                                { key: "compact", label: "Compact" },
                                { key: "normal", label: "Normal" },
                                { key: "relaxed", label: "Relaxed" },
                              ].map(({ key, label }) => (
                                <button
                                  key={key}
                                  className={`readingOptionChip ${this.state.readingLineHeight === key ? "readingOptionChipActive" : ""}`}
                                  onClick={() =>
                                    this.setState({ readingLineHeight: key })
                                  }
                                >
                                  {label}
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="readingOptionsSection">
                            <span className="readingOptionsLabel">
                              Letter Spacing
                            </span>
                            <div className="readingOptionsRow">
                              {[
                                { key: "normal", label: "Normal" },
                                { key: "wide", label: "Wide" },
                              ].map(({ key, label }) => (
                                <button
                                  key={key}
                                  className={`readingOptionChip ${this.state.readingLetterSpacing === key ? "readingOptionChipActive" : ""}`}
                                  onClick={() =>
                                    this.setState({ readingLetterSpacing: key })
                                  }
                                >
                                  {label}
                                </button>
                              ))}
                            </div>
                          </div>

                          <div className="readingOptionsSection">
                            <span className="readingOptionsLabel">
                              Color Scheme
                            </span>
                            <div className="readingOptionsColorRow">
                              {[
                                {
                                  key: "default",
                                  label: "Default",
                                  swatches: ["#e2ffdd", "#ffdddd", "#d1ecf1"],
                                },
                                {
                                  key: "mono",
                                  label: "Mono",
                                  swatches: ["#f0f0f0", "#8a8a8a", "#cbcbcb"],
                                },
                                {
                                  key: "sepia",
                                  label: "Sepia",
                                  swatches: ["#f0e8cf", "#b89a70", "#ddd0b0"],
                                },
                                {
                                  key: "cool",
                                  label: "Cool",
                                  swatches: ["#e8f4fc", "#7aafd4", "#c0daf0"],
                                },
                                {
                                  key: "highcontrast",
                                  label: "High Contrast",
                                  swatches: ["#003300", "#330000", "#00134d"],
                                },
                              ].map(({ key, label, swatches }) => (
                                <button
                                  key={key}
                                  className={`readingColorChip ${this.state.readingColorScheme === key ? "readingColorChipActive" : ""}`}
                                  onClick={() =>
                                    this.setState({ readingColorScheme: key })
                                  }
                                  title={label}
                                >
                                  <span className="readingColorSwatches">
                                    {swatches.map((bg, i) => (
                                      <span
                                        key={i}
                                        className="readingColorSwatch"
                                        style={{ backgroundColor: bg }}
                                      />
                                    ))}
                                  </span>
                                  <span className="readingColorLabel">
                                    {label}
                                  </span>
                                </button>
                              ))}
                            </div>
                          </div>

                          <button
                            className="readingOptionsReset"
                            onClick={() =>
                              this.setState(
                                {
                                  readingFontSize: "medium",
                                  readingFontFamily: "sans",
                                  readingLineHeight: "normal",
                                  readingLetterSpacing: "normal",
                                  readingColorScheme: "default",
                                },
                                this.saveReadingOptions,
                              )
                            }
                          >
                            Reset to defaults
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </motion.div>
            )}
            {this.state.grading && (
              <motion.div
                className="newGradingCaseDetailsWrapper"
                data-highlight-container="true"
                data-highlight-key="caseDetails"
                data-highlight-type="caseDetails"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key="newGradingCaseDetailsWrapper"
              >
                <div className="newGradingCaseDetailContainer">
                  <div className="newGradingCaseDetailIconContainer">
                    <FontAwesomeIcon
                      icon={faUser}
                      className="newGradingCaseDetailIcon"
                    />
                  </div>

                  <div className="newGradingCaseDetailTitleBlock">
                    <h3 className="newGradingCaseDetailTitle">Your Score</h3>
                    {!(
                      !this.state.grading.pgolist.TotalPointsEarned &&
                      !this.state.grading.pgolist.TotalPointsPossible
                    ) && (
                      <h3 className="newGradingCaseDetailTitle">
                        {this.state.grading.pgolist.TotalPointsEarned}/
                        {this.state.grading.pgolist.TotalPointsPossible} pts
                      </h3>
                    )}
                  </div>
                  <div className="newGradingCaseDetailValueRow">
                    <h2 className="newGradingCaseDetailValue">
                      {this.state.grading.GradeForCase
                        ? Math.round(this.state.grading.GradeForCase * 100) /
                          100
                        : 0}
                      %
                    </h2>
                    {!(
                      !this.state.grading.pgolist.TotalPointsEarned &&
                      !this.state.grading.pgolist.TotalPointsPossible
                    ) && (
                      <button
                        type="button"
                        className="reportCardButton"
                        onClick={this.openReportCardModal}
                        aria-label="View score breakdown"
                      >
                        <FontAwesomeIcon
                          icon={faChartSimple}
                          className="reportCardButtonIcon"
                        />
                      </button>
                    )}
                  </div>
                </div>

                <div className="newGradingCaseDetailContainer">
                  <div className="newGradingCaseDetailIconContainer">
                    <FontAwesomeIcon
                      icon={faUsers}
                      className="newGradingCaseDetailIcon"
                    />
                  </div>
                  <h3 className="newGradingCaseDetailTitle">
                    Average First Attempt Score
                  </h3>
                  <h2 className="newGradingCaseDetailValue">
                    {this.state.grading.AverageFirstAttempt
                      ? Math.round(
                          this.state.grading.AverageFirstAttempt * 100,
                        ) / 100
                      : 0}
                    %
                  </h2>
                </div>

                <div className="newGradingCaseDetailContainer">
                  <div className="newGradingCaseDetailIconContainer">
                    <FontAwesomeIcon
                      icon={faUserDoctorMessage}
                      className="newGradingCaseDetailIcon"
                    />
                  </div>
                  <h3 className="newGradingCaseDetailTitle">Case Diagnosis</h3>
                  <h2 className="newGradingCaseDetailValue">
                    {this.props.selectedCaseDiagnosis}
                  </h2>
                </div>
              </motion.div>
            )}
            {this.state.grading?.pgolist.pgolist.map((pgoValue, pgoIndex) => (
              <motion.div
                className="newGradingFeedbackItemContainer"
                data-highlight-container="true"
                data-highlight-key={`feedbackItem-${pgoIndex}`}
                data-highlight-type="feedbackItem"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key={`newGradingFeedbackItemContainer - ${pgoIndex}`}
              >
                <div className="newGradingCaseDetailTitleBlock">
                  <h2 className="newGradingFeedbackItemTitle">
                    Question {pgoIndex + 1}
                    {!this.state.grading.pgolist.TotalPointsEarned &&
                      !this.state.grading.pgolist.TotalPointsPossible &&
                      ` (${
                        pgoValue.grade
                          ? `${Math.round(pgoValue.grade * 100) / 100}%`
                          : "0%"
                      })`}{" "}
                    -{" "}
                    {
                      this.state.grading.qo.find(
                        (q) => q.QUESTIONID === pgoValue.QuestionId,
                      )?.QUESTION
                    }
                  </h2>
                  {this.renderPointsRing(
                    pgoValue.PointsEarned,
                    pgoValue.PointsPossible,
                    pgoValue,
                  )}
                </div>
                {/*<h2 className='newGradingFeedbackItemTitle'>Question {pgoIndex + 1} ({pgoValue.grade ? `${Math.round(pgoValue.grade * 100) / 100}%` : '0%'}) - {this.state.grading.qo[pgoIndex].QUESTION}</h2>}
                              {/* <h3 className='newGradingFeedbackItemValue'>Weight given for total score: {this.state.grading.GradeFeedback[section.weightValue]}%</h3> */}
                <div className="newGradingFeedbackItemContentWrapper">
                  <div
                    style={{
                      filter: `brightness(${this.props.themeNumber !== 0 ? 85 : 100}%)`,
                    }}
                    className={`newGradingFeedbackEvent userEntry`}
                  >
                    <div className="newGradingFeedbackEventHeader">
                      Your answer
                    </div>
                    <ul>
                      {pgoValue.PreviousInput[0].CustomerAnswersBlank
                        ? pgoValue.PreviousInput[0].CustomerAnswersBlank.map(
                            (inputValue, inputIndex) => (
                              <li
                                key={`Question${pgoIndex}Answer${inputIndex}`}
                              >
                                {inputValue === "" ? (
                                  <b>Option left blank</b>
                                ) : (
                                  inputValue
                                )}
                              </li>
                            ),
                          )
                        : pgoValue.PreviousInput[0].CustomerAnswerMC.map(
                            (inputValue, inputIndex) => (
                              <li
                                key={`Question${pgoIndex}Answer${inputIndex}`}
                              >
                                {this.getMultipleChoiceOption(
                                  inputValue,
                                  pgoValue.QuestionId,
                                )}
                              </li>
                            ),
                          )}
                    </ul>
                  </div>
                  {pgoValue.GradeOut.map((gradedValue, gradedIndex) => (
                    <div
                      style={{
                        filter: `brightness(${this.props.themeNumber !== 0 ? 85 : 100}%)`,
                        ...this.getReadingStyle(
                          gradedValue.GradeColor === "Correct - Green"
                            ? "correct"
                            : gradedValue.GradeColor === "Neutral - Blue"
                              ? "neutral"
                              : "incorrect",
                        ),
                      }}
                      className={`newGradingFeedbackAnswerWrapper ${
                        gradedValue.GradeColor === "Correct - Green"
                          ? "newGradingFeedbackAnswerCorrect"
                          : gradedValue.GradeColor === "Neutral - Blue"
                            ? "newGradingFeedbackAnswerNeutral" // New class for blue - added 3-29-2025
                            : "newGradingFeedbackAnswerIncorrect"
                      }`}
                    >
                      <h4
                        className="newGradingFeedbackAnswerTitle"
                        style={{ marginBottom: "15px" }}
                      >
                        {gradedValue.EventName}
                      </h4>
                      {gradedValue.OrderName && (
                        <ul className="newGradingFeedbackAnswerItemList">
                          {gradedValue.OrderName?.split("\\n").map((value) => (
                            <li className="newGradingFeedbackAnswerItem">
                              {value}
                            </li>
                          ))}
                        </ul>
                      )}
                      {gradedValue.Explanation && (
                        <p className="newGradingFeedbackReason">
                          <strong>Reason: </strong>
                          {gradedValue.Explanation}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
            {this.state.grading?.CaseSummary && (
              <motion.div
                className="newGradingCaseSummaryContainer"
                style={this.getReadingStyle()}
                data-highlight-container="true"
                data-highlight-key="caseSummary"
                data-highlight-type="caseSummary"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key="newGradingCaseSummaryContainer"
              >
                <h2
                  className="newGradingCaseSummaryTitle"
                  style={{ color: "inherit" }}
                >
                  Case Summary
                </h2>
                <p
                  className="newGradingCaseSummaryText"
                  style={{ color: "inherit" }}
                >
                  {this.state.grading.CaseSummary}
                </p>
              </motion.div>
            )}
            {this.state.grading && (
              <motion.div
                className="newGradingBackWrapper"
                initial={this.props.animationsDisabled ? false : { opacity: 0 }}
                animate={this.props.animationsDisabled ? false : { opacity: 1 }}
                exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                transition={{ duration: 0.2 }}
                key="newGradingBackWrapperFooter"
              >
                <button
                  className="tertiaryButton newGradingBackButton"
                  onClick={async () => {
                    await this.saveReadingOptions();
                    this.props.closeGrading();
                  }}
                >
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    className="newGradingBackIcon"
                  />
                  Back To Case List
                </button>
                {this.props.gradingMode !== "peek" && this.state.grading && (
                  <div
                    className="newGradingCheckboxContainer"
                    onClick={this.markHighYieldHandler}
                    style={{
                      gridTemplateColumns: "30px auto auto",
                      paddingRight: "10px",
                    }}
                  >
                    <div className="newGradingCheckbox">
                      {this.state.highYield && (
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="newGradingCheckboxIcon"
                        />
                      )}
                    </div>
                    <p className="newGradingCheckboxText">High Yield</p>
                    <FontAwesomeIcon
                      icon={faQuestionCircle}
                      className="highYieldMoreInfoButton"
                      onClick={this.highYieldHelpHandler}
                    />
                    {this.state.highYieldLoading && (
                      <div className="highYieldLoadingContainer">
                        <MDSpinner size={35} singleColor={"#fff"} />
                      </div>
                    )}
                  </div>
                )}
                <div
                  className="newGradingCheckboxContainer"
                  onClick={this.fetchReviewLater}
                  style={{ gridTemplateColumns: "30px auto" }}
                >
                  <div className="newGradingCheckbox">
                    {this.state.reviewLater && (
                      <FontAwesomeIcon
                        icon={faCheck}
                        className="newGradingCheckboxIcon"
                      />
                    )}
                  </div>
                  <p className="newGradingCheckboxText">Review Later</p>
                  {this.state.reviewLaterLoading && (
                    <div className="highYieldLoadingContainer">
                      <MDSpinner size={30} singleColor={"#fff"} />
                    </div>
                  )}
                </div>
              </motion.div>
            )}
            <AnimatePresence>
              {this.state.showFeedbackModal && (
                <motion.div
                  className="feedbackModalOverlay"
                  initial={
                    this.props.animationsDisabled ? false : { opacity: 0 }
                  }
                  animate={
                    this.props.animationsDisabled ? false : { opacity: 1 }
                  }
                  exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  onClick={this.closeFeedbackModal}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000,
                  }}
                >
                  <motion.div
                    className="feedbackModalContent"
                    initial={
                      this.props.animationsDisabled
                        ? false
                        : { scale: 0.9, opacity: 0 }
                    }
                    animate={
                      this.props.animationsDisabled
                        ? false
                        : { scale: 1, opacity: 1 }
                    }
                    exit={
                      this.props.animationsDisabled
                        ? false
                        : { scale: 0.9, opacity: 0 }
                    }
                    transition={{ duration: 0.2 }}
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      backgroundColor:
                        this.props.selectedTheme?.secondaryBackgroundColor ||
                        "#fff",
                      borderRadius: "12px",
                      padding: "24px",
                      width: "90%",
                      maxWidth: "500px",
                      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                    }}
                  >
                    <h2
                      style={{
                        margin: "0 0 16px 0",
                        color:
                          this.props.selectedTheme?.primaryTextColor || "#333",
                      }}
                    >
                      Send Feedback
                    </h2>
                    {this.state.feedbackSubmitted ? (
                      <div style={{ textAlign: "center", padding: "20px 0" }}>
                        <FontAwesomeIcon
                          icon={faCheck}
                          style={{
                            fontSize: "48px",
                            color: "#4CAF50",
                            marginBottom: "16px",
                          }}
                        />
                        <p
                          style={{
                            color:
                              this.props.selectedTheme?.primaryTextColor ||
                              "#333",
                            fontSize: "16px",
                          }}
                        >
                          Thank you for your feedback!
                        </p>
                      </div>
                    ) : (
                      <>
                        <textarea
                          value={this.state.feedbackText}
                          onChange={(e) =>
                            this.setState({ feedbackText: e.target.value })
                          }
                          placeholder="Share your thoughts, suggestions, or report issues..."
                          style={{
                            width: "100%",
                            minHeight: "120px",
                            padding: "12px",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                            fontSize: "14px",
                            resize: "vertical",
                            boxSizing: "border-box",
                            fontFamily: "inherit",
                          }}
                        />
                        {this.state.feedbackError && (
                          <p
                            style={{
                              color: "#f44336",
                              fontSize: "14px",
                              margin: "8px 0 0 0",
                            }}
                          >
                            {this.state.feedbackError}
                          </p>
                        )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                            marginTop: "16px",
                          }}
                        >
                          <button
                            className="tertiaryButton"
                            onClick={this.closeFeedbackModal}
                            style={{ padding: "10px 20px" }}
                          >
                            Cancel
                          </button>
                          <button
                            className="tertiaryButton"
                            onClick={this.submitFeedback}
                            disabled={
                              this.state.feedbackLoading ||
                              !this.state.feedbackText.trim()
                            }
                            style={{
                              padding: "10px 20px",
                              opacity:
                                this.state.feedbackLoading ||
                                !this.state.feedbackText.trim()
                                  ? 0.6
                                  : 1,
                            }}
                          >
                            {this.state.feedbackLoading ? (
                              <MDSpinner size={16} singleColor={"#fff"} />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </>
                    )}
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
            <AnimatePresence>
              {this.state.showReportCardModal && this.state.grading && (
                <motion.div
                  className="reportCardModalOverlay"
                  initial={
                    this.props.animationsDisabled ? false : { opacity: 0 }
                  }
                  animate={
                    this.props.animationsDisabled ? false : { opacity: 1 }
                  }
                  exit={this.props.animationsDisabled ? false : { opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  onClick={this.closeReportCardModal}
                >
                  <motion.div
                    className="reportCardModalContent"
                    initial={
                      this.props.animationsDisabled
                        ? false
                        : { scale: 0.9, opacity: 0 }
                    }
                    animate={
                      this.props.animationsDisabled
                        ? false
                        : { scale: 1, opacity: 1 }
                    }
                    exit={
                      this.props.animationsDisabled
                        ? false
                        : { scale: 0.9, opacity: 0 }
                    }
                    transition={{ duration: 0.2 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="reportCardHeader">
                      <div className="reportCardHeaderTitleBlock">
                        <h2 className="reportCardHeaderTitle">
                          Case {this.state.selectedCaseData?.ID} point breakdown
                        </h2>
                      </div>
                      <div className="reportCardEnd">
                        {" "}
                        <p className="reportCardHeaderMeta">
                          {this.state.grading.pgolist.pgolist.length} question
                          {this.state.grading.pgolist.pgolist.length === 1
                            ? ""
                            : "s"}
                          {this.state.grading.pgolist.pgolist[0] &&
                            `, ${
                              this.state.grading.pgolist.pgolist[0]
                                .PointsPossible
                            } pts each`}
                        </p>{" "}
                        <button
                          type="button"
                          className="reportCardCloseButton"
                          onClick={this.closeReportCardModal}
                          aria-label="Close report card"
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      </div>
                    </div>
                    <div className="reportCardList">
                      {this.state.grading.pgolist.pgolist.map(
                        (pgoValue, pgoIndex) => {
                          const question = this.state.grading.qo.find(
                            (q) => q.QUESTIONID === pgoValue.QuestionId,
                          )?.QUESTION;
                          const earned =
                            Math.round((pgoValue.PointsEarned || 0) * 10) / 10;
                          const possible =
                            Math.round((pgoValue.PointsPossible || 0) * 10) /
                            10;
                          return (
                            <div
                              className="reportCardRow"
                              key={`reportCardRow-${pgoIndex}`}
                            >
                              <p className="reportCardRowLabel">
                                Q{pgoIndex + 1} &middot; {question}
                              </p>
                              <p className="reportCardRowValue">
                                {earned}/{possible}
                              </p>
                            </div>
                          );
                        },
                      )}
                    </div>
                    {!(
                      !this.state.grading.pgolist.TotalPointsEarned &&
                      !this.state.grading.pgolist.TotalPointsPossible
                    ) && (
                      <div className="reportCardTotalRow">
                        <p className="reportCardTotalLabel">Total</p>
                        <p className="reportCardTotalValue">
                          {Math.round(
                            (this.state.grading.pgolist.TotalPointsEarned ||
                              0) * 10,
                          ) / 10}
                          /
                          {Math.round(
                            (this.state.grading.pgolist.TotalPointsPossible ||
                              0) * 10,
                          ) / 10}{" "}
                          (
                          {this.state.grading.GradeForCase
                            ? Math.round(
                                this.state.grading.GradeForCase * 100,
                              ) / 100
                            : 0}
                          %)
                        </p>
                      </div>
                    )}
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
            <AnimatePresence>
              {this.state.viewPreviousCompletions && (
                <ViewCompletionsPopup
                  closePopup={() =>
                    this.setState({ viewPreviousCompletions: false })
                  }
                  previousCompletionSelected={
                    this.state.previousCompletionSelected
                  }
                  previousCompletions={this.state.previousCompletions}
                  updatePreviousCompletionSelected={(newSelection) =>
                    this.setState({ previousCompletionSelected: newSelection })
                  }
                  confirm={(caseId) => this.fetchRetrieveCaseGrade(caseId)}
                  timeZone={this.props.userData.TimeZone}
                  primaryColor={this.props.primaryColor}
                  key="viewCompletionsPopupComponent"
                  animationsDisabled={this.props.animationsDisabled}
                />
              )}
            </AnimatePresence>
          </AnimatePresence>
        </div>
      </GamificationToastWrapper>
    );
  }
}
